// extracted by mini-css-extract-plugin
module.exports = {"center":"_eMgS7LD"};